export default __webpack_public_path__ + "static/media/IBMPlexSans-Text.375c9b2d.woff";